import { ReviewCard } from '../../../components/wizard/ReviewCard';
import { NavigationButtons } from '../../../components/wizard/NavigationButtons';

export function Step7Review() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-white">Review Your Selections</h2>
        <p className="text-sm text-slate-500 mt-1">
          Make sure everything is correct before generating questions.
        </p>
      </div>
      <ReviewCard />
      <NavigationButtons nextLabel="Looks Good, Continue" />
    </div>
  );
}
